module.exports = __webpack_public_path__ + "static/img/customer.9ad905b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customer.png
// module id = CKgL
// module chunks = 1